var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { cachedSet } from '../../../../../utils/mobx/decorators/customComputed';
import { traitRegistry } from '../../../../../registry/Registry';
import { flatten, uniq } from '../../../../../utils/helper/lodash_replacements';
import { createsTrait } from '../../../../../registry/trait/TraitRegistryDependencies';
export class AspectTraits {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    traitsOfKey(traitKey) {
        return this.aspect.traits.filter(t => t.key === traitKey);
    }
    get traitsByIdObject() {
        return this.aspect.traits.reduce((ret, trait) => {
            ret[trait.id] = trait;
            return ret;
        }, {});
    }
    get traitKeys() {
        return uniq(this.aspect.aspectImport.traitsWithImported.map(at => at.key)).filter(traitKey => traitRegistry.registry_object[traitKey]);
    }
    get traitKeysWithDerived() {
        // const refreshOnNewPackage = runtime.availablePackages.allAvailablePackages;
        const derivedTraitKeys = this.traitKeys.map(traitKey => createsTrait[traitKey] || []);
        return [...this.traitKeys, ...flatten(derivedTraitKeys)];
    }
}
__decorate([
    computed
], AspectTraits.prototype, "traitsByIdObject", null);
__decorate([
    cachedSet
], AspectTraits.prototype, "traitKeys", null);
__decorate([
    cachedSet
], AspectTraits.prototype, "traitKeysWithDerived", null);
